import {SearchTypes} from "../../types/common/search.types";
import apiClient from '../apiClient';
import {ResponseDto} from "../ResponseDto";
import {PageTypes} from "../../types/page.types";
import {PayUseDetailTypes, PayUseTypes} from "../../types/transaction/transaction.types";
export const getMemberPayUseList = (searchData: SearchTypes) =>
    apiClient.get<ResponseDto<PageTypes>>("/api/front/pay/getMemberPayUseList",
    {
        params: searchData,
        headers: {'Content-Type': 'application/json'}
    }
);


export const getMemberPayUseDetail = (transactionCode : string, useType: string) =>
    apiClient.get<ResponseDto<PayUseDetailTypes>>("/api/front/pay/getMemberPayUseDetail",
        {
            params: {transactionCode, useType},
            headers: {'Content-Type': 'application/json'}
        }
    );

export const getPaymentInfo = (jobPostingCode: string, coordinatorCode: string) =>
    apiClient.get<{
        balance: number;
        jobData: any;
        coordiData: any;
        paymentFeeRate: number;
    }>(`/api/front/pay/infoForPayment`, {
        params: { jobPostingCode, coordinatorCode }
    });
export const processPayment = (data: {
    jobPostingCode: string;
    coordinatorCode: string;
    amount: number;
    paymentMethod: string;
    }) => apiClient.post<ResponseDto<any>>(`/api/front/pay/process`, data);

// api/transaction/payApi.ts
export const cancelReservation = (jobPostingCode: string) =>
    apiClient.post<ResponseDto<any>>(`/api/front/pay/cancel-reservation`, { jobPostingCode });